module.exports = __webpack_public_path__ + "img/sleeve_binding_width.c48c6f28.png";